import { render, staticRenderFns } from "./CaseCategoryForm.vue?vue&type=template&id=19dab191&"
import script from "./CaseCategoryForm.vue?vue&type=script&lang=js&"
export * from "./CaseCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports